import UploadFile from "components/importImage";
import { useFormik } from "formik";
import DatePickers from "global/DatePicker/DatePicker";
import InputNumber from "global/InputNumber/InputNumber";
import InputText from "global/InputText/InputText";
import Modal from "global/Modal/Modal";
import SimpleButton from "global/SimpleButton/SimpleButton";
import { useState } from "react";

function BankDelivery({ open, setOpen }) {
  const [openImageModal, setOpenImageModal] = useState(false);
  const { handleSubmit, handleChange, values, touched, errors, setFieldValue } =
    useFormik({
      enableReinitialize: true,
      // validationSchema: AssignmentValidation,
      initialValues: {
        code: "",
        payedPrice: "",
        deliveryDateDto: "",
        deliveryTime: "",
      },
      onSubmit: () => {},
    });

  function refreshTable() {}
  return (
    <Modal visible={open} setVisible={setOpen} title="مشخصات رسید بانکی">
      <form onSubmit={handleSubmit}>
        <div className="grid2">
          <InputText
            label="شماره  سند"
            name="code"
            handleChange={handleChange}
            values={values.code}
            important
            error={touched.code && errors.code}
            wrapperClassName="w-full"
          />
          <DatePickers
            WrapperClassName="w-full "
            time
            important
            title="تاریخ "
            values={values.deliveryDateDto}
            name="deliveryDateDto"
            handleChange={setFieldValue}
            timeName="deliveryTime"
            timeValues={values.deliveryTime}
            error={touched.deliveryTime && errors.deliveryTime}
          />
          <InputNumber
            label="مبلغ پرداخت شده"
            name="payedPrice"
            handleChange={handleChange}
            values={values.payedPrice}
            important
            error={touched.payedPrice && errors.payedPrice}
            wrapperClassName="w-full"
          />
        </div>
        <UploadFile
          OpenModal={true}
          setUpdate={refreshTable}
          setOpenModal={setOpenImageModal}
        />
        <div className="btnForm">
          <SimpleButton
            handelClick={() => setOpen({ ...open, bankDelivery: false })}
            text="انصراف"
            className="text-tomato"
          />
          <SimpleButton
            type="submit"
            text=" ذخیره"
            className="full-tomato-btn"
          />
        </div>
      </form>
    </Modal>
  );
}

export default BankDelivery;
